import { render } from "./AddDocumentTypeCnfPopUpNew.vue?vue&type=template&id=003a8af4&scoped=true"
import script from "./AddDocumentTypeCnfPopUpNew.vue?vue&type=script&lang=js"
export * from "./AddDocumentTypeCnfPopUpNew.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
import "./AddDocumentTypeCnfPopUpNew.vue?vue&type=style&index=1&id=003a8af4&scoped=true&lang=css"
import "./AddDocumentTypeCnfPopUpNew.vue?vue&type=style&index=2&id=003a8af4&lang=css"

import exportComponent from "/var/www/dev.newtoncommoditiesscripts.com/vue-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-003a8af4"]])

export default __exports__